module.exports = __webpack_public_path__ + "static/media/browser-firefox.bba24fe8.svg";